import { Row } from 'antd';
import styled, { css } from 'styled-components';

import { StyledTimeType } from './types';

export const UsersWrapper = styled(Row)`
  padding: var(--padding-lg);
  background-color: var(--layout-body-background);
  gap: 24px;
`;

export const StyledTime = styled.button<StyledTimeType>`
  width: 74px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #eff3ff;
  border-radius: 12px;
  padding: 14px;
  transition: all 0.4s;
  font-size: 14px;
  line-height: 19px;
  color: #0e2f5c;
  cursor: pointer;
  border: none;
  ${({ active }) =>
    active &&
    css`
      background-color: #0b1a30;
      color: #ffffff;
    `}
  ${({ disabled }) =>
    disabled &&
    css`
      opacity: 0.7;
      cursor: default;
      cursor: not-allowed;
    `}
`;

export const StyledContainer = styled.div`
  display: flex;
  align-items: center;
  border: 1px solid #c8d2e6;
  width: 100%;
  border-radius: 8px;
  padding: 12px;
`;

export const StyledDatesContainer = styled.div`
  width: 55%;
`;

export const StyledDateContainer = styled.div`
  border: 0 solid #c8d2e6;
  border-width: 0 1px 0 0;
  padding-right: 26px;
`;

export const StyledDate = styled.h3`
  font-size: 14px;
  color: #0b1a30;
  margin-bottom: 0;
  white-space: nowrap;
`;
